import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { AlertProvider } from '@ascend/alert';
import { AppLockProvider } from '@/components/AppLock';
import { AppGate } from './AppGate';
import { ensureDBSchema } from '@/persistence/db';
import './index.css';
import './app.css';
import 'calc-controls/styles.css';
import './cc-overrides.css';
import 'calc-nav/styles.css';
import 'calc-sidebar/styles.css';
import './components/AppLock/applock.css';
import './components/FeedbackForm/feedback.css';

async function bootstrap(): Promise<void> {
  registerSW({ onNeedRefresh() {}, onOfflineReady() {} });
  await ensureDBSchema();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AlertProvider>
        <BrowserRouter>
          <AppLockProvider>
            <AppGate />
          </AppLockProvider>
        </BrowserRouter>
      </AlertProvider>
    </StrictMode>,
  );
}

void bootstrap();
